import React from "react";
import PreParser from "../components/preParser";
import Content from "../components/blocks/gco/content";
import PostTitle from "../components/blocks/core/post-title";
import PostDate from "../components/blocks/core/post-date";
import PostFeaturedImage from "../components/blocks/core/post-featured-image";
import PostTerms from "../components/blocks/core/post-terms";
import Layout from "../components/layout/layout";
import JobPostingsMicrodata from "../components/jobposting-microdata";
/*
 *         child={ postContent }
        title={ post.title }
        coverImage={ post.featuredImage ? post.featuredImage.node : undefined }
        terms={{
          nodes: post.categories.nodes,
          asList: false,
          asLink: true
        }}
        date={ post.date }
*/
/*
        <Content>
          <PostContent />
        </Content>
        <PostTitle>{ post.title }</PostTitle>
        <PostImage>{ post.featuredImage ? post.featuredImage.node : undefined }</PostImage>
        <PostDate>{ post.date }</PostDate>
        <Terms asList={ false } asLink={ true }>{ post.categories.nodes }</Terms>
*/
//~ const PostContent = () => (<p>CONTENT</p>)
const Post = (props) => {
    //~ const template = props.data ? props.data.wpTemplate.jsonContent : props.template;
    const PostContent = () => {
        return React.createElement(PreParser, { structure: props.data.wpPost.jsonContent });
    };
    const hasJobPostings = props.data.siteMeta.siteMetadata.hasJobPostings;
    {
        hasJobPostings &&
            typeof props.data.wpPost.gcoRecrutement !== "undefined" &&
            props.data.wpPost.gcoRecrutement.descriptionDeLoffre !== null ? (React.createElement(JobPostingsMicrodata, { post: props.data.wpPost })) : (React.createElement(React.Fragment, null));
    }
    return (React.createElement(Layout, { infos: {
            title: props.data.wpPost.title,
            postType: "post",
            category: props.data.wpPost.categories.nodes[0],
            parents: props.pageContext.parents,
            published: props.data.wpPost.date,
            updated: props.data.wpPost.modified,
            path: props.path,
        }, seo: props.data.wpPost.seo, data: props.data },
        React.createElement(PreParser, { structure: props.data.wpTemplate.jsonContent },
            React.createElement(Content, null,
                React.createElement(PostContent, null)),
            React.createElement(PostTitle, null, props.data.wpPost.title),
            React.createElement(PostFeaturedImage, null, props.data.wpPost.featuredImage
                ? props.data.wpPost.featuredImage.node
                : undefined),
            React.createElement(PostDate, null, props.data.wpPost.date),
            React.createElement(PostTerms, { asList: false, asLink: true }, props.data.wpPost.categories.nodes))));
};
export default Post;
